import { Helmet } from 'react-helmet-async';

const faqs = [
    {
        question: "Mistä takaisinvetotiedot tulevat?",
        answer: "Tiedot kerätään Ruokavirastolta ja Tukesilta, joilta on saatu lupa tietojen käyttöön. Sivusto päivittyy automaattisesti aina, kun uusi takaisinveto julkaistaan."
    },
    {
        question: "Onko Takaisinvedot-sovellus ilmainen?",
        answer: "Kyllä, sekä sivusto että Android-sovellus ovat täysin ilmaisia käyttää."
    },
    {
        question: "Miten saan ilmoituksen heti, kun uusi takaisinveto julkaistaan?",
        answer: "Lataa Takaisinvedot-sovellus Google Playsta ja salli ilmoitukset. Saat puhelimeesi ilmoituksen heti, kun uusi takaisinveto ilmestyy, etkä joudu itse tarkistamaan sivustoa."
    },
    {
        question: "Voinko palauttaa takaisinvedetyn tuotteen ja saada rahat takaisin?",
        answer: "Usein kyllä, mutta tästä on aina maininta tai tarkemmat toimintaohjeet itse takaisinvetoilmoituksessa. Tuotteen käyttö kannattaa joka tapauksessa lopettaa heti, jos se on todettu vaaralliseksi."
    }
];

const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
        }
    }))
};

const About = () => {
    return (
        <div className="aboutContainer">
            <Helmet>
                <title>Mikä on Takaisinvedot? – Takaisinvedot</title>
                <meta
                    name="description"
                    content="Takaisinvedot kokoaa kaikki Suomen tuotteiden takaisinvedot yhteen paikkaan Ruokavirastolta ja Tukesilta. Lue, miten sivusto ja sovellus toimivat."
                />
                <link rel="canonical" href={`${window.location.origin}/about`} />
                <script type="application/ld+json">
                    {JSON.stringify(faqStructuredData)}
                </script>
            </Helmet>

            <h1>Mikä on Takaisinvedot?</h1>
            <p>
                Takaisinvedot kerää kaikki Suomen tuotteiden takaisinvedot yhteen paikkaan.
                Takaisinveto tarkoittaa tuotteen poistamista myynnistä koko maassa siinä ilmenneen vian vuoksi.
                Takaisinvedot voivat koskea elintarvikkeita sekä muita tuotteita.
                Osa tavaroista on tarkoitettu ammattikäyttöön ja osa kuluttajille.
            </p>
            <p>
                Usein takaisinvedetyn tuotteen voi palauttaa myyjälle ja saada siitä rahat takaisin.
                Tästä on kuitenkin maininta tai muut toimintaohjeet takaisinvetoilmoituksessa.
                Joka tapauksessa tuotteen käyttö on syytä lopettaa heti, jos se on todettu vaaralliseksi.
            </p>
            <p>
                Takaisinvedon syynä voi olla esimerkiksi vierasesineet tai ilmoittamattomat allergeenit, jos kyseessä on elintarvike.
                Muissa tavaroissa takaisinvedon syynä voi olla sähköiskun tai tulipalon vaara, rajoitukset ylittävä haitallisen aineen määrä, kuten lyijypitoisuus, tai puutteelliset turvaominaisuudet.
            </p>
            <p>
                Lähteinä toimivat muun muassa Ruokavirasto ja Tukes, joilta on saatu lupa tietojen käyttöön.
            </p>

            <h2>Takaisinvedot-sivuston käyttö</h2>
            <p>
                Etusivulla näet kaikki Suomen takaisinvedot aikajärjestyksessä.
                Selaamalla alaspäin näet vanhemmat takaisinvedot usean vuoden ajalta.
            </p>
            <p>
                Ruudun alareunassa löytyy haku- ja suodatustoiminto.
                Voit hakea takaisinvetoja hakusanalla tai suodattaa tyypin mukaan.
                Syötettyäsi hakusanan tai valittuasi pelkät elintarvikkeet tai tavarat, muista klikata "Hae"-painiketta.
                Voit palauttaa näkymään kaikki takaisinvedot painamalla "Tyhjennä"-painiketta.
            </p>

            <h2>Takaisinvedot-sovellus</h2>
            <p>
                Takaisinvedot toimii sekä takaisinvedot.fi-sivustolla että samannimisellä Android-sovelluksella.
                Sovelluksen etuna on se, että saat puhelimeesi ilmoituksen heti, kun uusi takaisinveto julkaistaan,
                etkä joudu itse tarkistamaan sivustoa pysyäksesi ajan tasalla.
            </p>
            <a
                href="https://play.google.com/store/apps/details?id=fi.takaisinvedot.app&utm_source=web&utm_medium=about&utm_campaign=android_from_web"
                target="_blank"
                rel="noopener noreferrer"
                className="google-play-badge"
            >
                <img
                    src="/GetItOnGooglePlay_Badge_Web_color_Finnish.svg"
                    alt="Lataa sovellus Google Playsta"
                    style={{ width: '180px' }}
                />
            </a>

            <h2>Usein kysytyt kysymykset</h2>
            {faqs.map((faq, index) => (
                <div key={index} className="faq-item">
                    <h3>{faq.question}</h3>
                    <p>{faq.answer}</p>
                </div>
            ))}
        </div>
    )
}
export default About
